/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import DeleteIcon from "@mui/icons-material/Delete"

const DeleteModal = ({ open, onClose, onDelete, isBtnLoading }) => {
  const handleDeleteClicked = () => {
    onDelete()
  }

  return (
    <div>
      <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
        <DialogTitle
          sx={{ backgroundColor: "#ca4343", color: "#fff" }}
          textAlign="center"
        >
          Are you sure you want to delete ?
        </DialogTitle>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose} variant="outlined" color="error">
            Cancel
          </Button>

          <LoadingButton
            loading={isBtnLoading}
            onClick={handleDeleteClicked}
            color="error"
            variant="contained"
            loadingPosition="start"
            startIcon={<DeleteIcon />}
          >
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DeleteModal
